// TODO: DANGEROUS - PLEASE REMOVE @ts-nocheck WHEN POSSIBLE
// @ts-nocheck - this file has a number of typescript errors which are out of scope for the coin migration
// Dependencies
import React from 'react';

// Utils
import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';

import { Box } from '@nerdwallet/currency';

// Local Components
import RCResultsPanelInsight from '../rc-results-panel-insight/rc-results-panel-insight';

import DetailsTable from './details-table/details-table';
import { RCDetailsTableAccordion } from './details-table/rc-details-table-accordion-config';
import Header from './header/header';
import LoanTermSlider from './loan-term-slider/loan-term-slider';

// @ts-ignore - ignore error
import style from './rc-results-panel.module.less';

interface RCResultsPanelProps {
  data: Record<string, any>;
  detailsTableConfig: RCDetailsTableAccordion[];
  isSignedIn: boolean;
  onChange: (config: any, value: any) => void;
}

const RCResultsPanel: React.FC<RCResultsPanelProps> = ({
  data,
  onChange,
  detailsTableConfig,
  isSignedIn,
}) => {
  const refinanceGoal = get(data, 'inputs.refinanceGoal');

  return (
    <Box
      className={classnames(
        style['rc-results-panel'],
        style[`rc-results-panel-${refinanceGoal}`]
      )}
    >
      <Header data={data} />
      <LoanTermSlider
        className={style['rc-results-panel-loan-term-slider']}
        data={data}
        onChange={onChange}
      />
      <RCResultsPanelInsight
        className={style['rc-results-panel-rcpi']}
        data={data}
        isSignedIn={isSignedIn}
      />
      <DetailsTable
        className={style['rc-results-panel-details-table']}
        viewConfig={detailsTableConfig}
      />
    </Box>
  );
};

RCResultsPanel.displayName = 'RCResultsPanel';

export default RCResultsPanel;
